"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { ExternalLink, CheckSquare, Ticket } from "lucide-react";

interface ComposeFormActionsProps {
  hasUnfilledVariables?: boolean;
  onGoToFullScreen?: () => void;
  /** Show the "Full Screen" hand-off button. Hidden on inline surfaces. */
  showFullScreenButton?: boolean;
  onCancel?: () => void;
  onCreateTask?: () => void;
  onCreateTicket?: () => void;
  originalMessage?: any;
  isSending?: boolean;
  sendFromEmail?: string;
}

export function ComposeFormActions({
  hasUnfilledVariables,
  onGoToFullScreen,
  showFullScreenButton = true,
  onCancel,
  onCreateTask,
  onCreateTicket,
  originalMessage,
  isSending,
  sendFromEmail,
}: ComposeFormActionsProps): React.ReactNode {
  const sendLabel = sendFromEmail ? `Send from ${sendFromEmail}` : "Send";

  return (
    <div className="flex justify-between items-center pt-4">
      {/* Left side - Create Task / Create Ticket buttons (only show for replies) */}
      <div className="flex gap-2">
        {originalMessage && onCreateTask && (
          <Button type="button" variant="outline" onClick={onCreateTask} className="gap-2">
            <CheckSquare className="h-4 w-4" />
            Create Task
          </Button>
        )}
        {originalMessage && onCreateTicket && (
          <Button type="button" variant="outline" onClick={onCreateTicket} className="gap-2">
            <Ticket className="h-4 w-4" />
            Create Ticket
          </Button>
        )}
      </div>

      {/* Right side - Action buttons */}
      <div className="flex gap-2">
        {showFullScreenButton && (
          <Button
            type="button"
            variant="outline"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (process.env.NODE_ENV === "development") {
                console.log("🔘 Full Screen button clicked");
              }
              onGoToFullScreen?.();
            }}
            className="gap-2"
          >
            <ExternalLink className="h-4 w-4" />
            Full Screen
          </Button>
        )}
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={isSending}>
          {isSending ? "Sending..." : hasUnfilledVariables ? "Review Variables" : sendLabel}
        </Button>
      </div>
    </div>
  );
}
